// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:"https://driver24x7-back.onrender.com/" ,
});

export default axiosInstance;

export const weburl = "https://driver24x7-back.onrender.com/";
// export const weburl = "https://driver24x7-back.onrender.com/";

export const Homeurl = "https://driver.spacedeco.in/";
export const adminurl = "https://admindriver.spacedeco.in/";
export const keyLogin = '6790eedec0468755d4a7a631';
export const LiveURL = 'https://secure.payu.in/_payment';
export const TestURL = 'https://driver24x7-back.onrender.com/';
export const MAPKEY = 'AIzaSyDcF0UUvCbBPe4Sfrm3KL2y3RLKd9E5CDM';
// export const weburl = 'https://backend-2o7f.onrender.com/';
